<template>
    <div class="kohota-flats active">
        <div class="container">
            <div class="flats-navigation" v-if="salesCard.project_land_site.flats_nav_init == 'true'">
                <ul>
                    <li v-for="(item, index) in salesCard.project_land_site.flats_nav" :key="index" :class="{'active' : activeFlats == item.id}">
                        <a :href="item.id" @click.prevent="changeActiveFlatsClass(item.id)">{{item.name}}</a>
                    </li>
                </ul>
            </div>
            <div class="plans-flats" v-if="activeFlats == 'flats'">
                <flatsFilter></flatsFilter>
                <flatsCards></flatsCards>
            </div>
            <div class="plans-villa" v-if="activeFlats == 'houses'">
                <flatsFilter></flatsFilter>
                <flatsCards></flatsCards>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
	import flatsFilter from '@/components/sales-land-partials/partials/kohota-flats-partials/flat-filter.vue'
	import flatsCards from '@/components/sales-land-partials/partials/kohota-flats-partials/flat-cards-kohota.vue'
    export default {
        name: 'sales-aqualina-flats',
        components: {
            flatsFilter,
            flatsCards,
        },
        data () {
            return {
                modalWidth: 1000,
				modalHeight: 640,
				modalScroll: false,
				formActive: false,
				mobile: false,
				transitionName: '',
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            modalData: 'loadSalesLandModalDataArr',
            salesCardFlats: 'loadFlatsCardsGlobal',
            salesCardFlatsDefault: 'loadFlatsCardsGlobalDefault',
            activeFlats: 'loadActiveFlatsClassKohOta',
        }),
        methods: {
            settingDataFlatsCardModal(arr) {
				
				this.$store.commit('modalData', arr);
                console.log(this.modalData)
				this.$modal.show('sales_land_flat-card-modal');
				// this.$store.commit('Open_Form_Modal', false);
				// document.getElementById('secret-btns').classList.remove('fadeIn');
			},
            FlatCardModalClosed() {
				// this.formActive = false;
				window.body.removeClass('overflowTrue');
				// document.getElementById('secret-btns').classList.remove('hideAll');
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('landNav').classList.remove('notvisibleSalesLand');
                // document.getElementById('banerTopHorizont').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
			},
			FlatCardModalOpened() {
				window.Sharer.init();
				window.body.addClass('overflowTrue');
				// document.getElementById('secret-btns').classList.add('hideAll');
				document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('landNav').classList.add('notvisibleSalesLand');
                // document.getElementById('banerTopHorizont').classList.add('notvisibleSalesLand');
                document.getElementById('footer').classList.add('notvisibleSalesLand');
			},
            changeActiveFlatsClass(data) {
                this.$store.commit('changeActiveFlatsClass', data);
                this.$store.commit('updateFlatsKohOta', data);
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/partials/kohota-flats.scss';
    @import '@/styles/respond/sales/sales-land-partials/partials/kohota-flats-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-about-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>